/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Addopportunityowner_Modal_Header3Inputs */

const en_coinvestments_addopportunityowner_modal_header3 = /** @type {(inputs: Coinvestments_Addopportunityowner_Modal_Header3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Opportunity Owner`)
};

/**
* | output |
* | --- |
* | "Edit Opportunity Owner" |
*
* @param {Coinvestments_Addopportunityowner_Modal_Header3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_addopportunityowner_modal_header3 = /** @type {((inputs?: Coinvestments_Addopportunityowner_Modal_Header3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Addopportunityowner_Modal_Header3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_addopportunityowner_modal_header3(inputs)
});
export { coinvestments_addopportunityowner_modal_header3 as "coInvestments_addOpportunityOwner_modal_header" }